import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect map (#592, PARITY.md §5): this surface moved under `sending/*`.
// PARITY.md routes the five Sending-bound old paths at the hub because the
// prototype has no sub-paths to aim at; this implementation ships them as real
// interim routes (D-592-1), so the redirect lands on the exact page instead of
// the hub — an old bookmark keeps its destination, not just its neighbourhood.
// PARITY.md §5 calls deep-link precision "an implementation choice, not an IA
// decision". When #593 folds these into one surface it retargets them again.
export const Route = createFileRoute("/dashboard/w/$workspaceId/events")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/sending/events",
      params: { workspaceId: params.workspaceId },
    });
  },
});
